import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./ImportMutationBankUIHelpers";

const ImportMutationBankUIContext = createContext();

export function useImportMutationBankUIContext() {
  return useContext(ImportMutationBankUIContext);
}

export const ImportMutationBankUIConsumer =
  ImportMutationBankUIContext.Consumer;

export function ImportMutationBankUIProvider({
  importMutationImportMutationBankUIEvents,
  children,
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    newImportMutationBankButtonClick:
      importMutationImportMutationBankUIEvents.newImportMutationBankButtonClick,
    openEditImportMutationBankPage:
      importMutationImportMutationBankUIEvents.openEditImportMutationBankPage,
  };

  return (
    <ImportMutationBankUIContext.Provider value={value}>
      {children}
    </ImportMutationBankUIContext.Provider>
  );
}
